
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/home-medical-care",
      function () {
        return require("private-next-pages/special/home-medical-care/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/home-medical-care"])
      });
    }
  